import { createSlice } from "@reduxjs/toolkit";
import { setAccountSecret } from "../auth/auth";
var initialState = {
    accounts: []
};
export var accountsMiddleware = function(store) {
    return function(next) {
        return function(action) {
            if (accountsSlice.actions.setAccounts.match(action)) {
                var accountId = store.getState().auth.accountId;
                var account = action.payload.find(function(param) {
                    var key = param.key;
                    return key === accountId;
                });
                if (account) {
                    store.dispatch(setAccountSecret(account.secret));
                }
            }
            return next(action);
        };
    };
};
var accountsSlice = createSlice({
    initialState: initialState,
    name: "accounts",
    reducers: {
        setAccounts: function(state, param) {
            var payload = param.payload;
            state.accounts = payload;
        }
    }
});
export var setAccounts = accountsSlice.actions.setAccounts;
export var accountsReducer = accountsSlice.reducer;

//# sourceMappingURL=accounts.js.map